import base from "../baseurl";
import token from "../getTk";

const Delete = async (goodDeliveryEventId, states) => {
  const tokenA = token.get();
  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });
  const Create = await api
    .post("good-delivery-participants/showall", {
      json: {
        goodDeliveryEventId,
        states,
      },
    })
    .json();
  console.log(Create, goodDeliveryEventId, states);
  return Create;
};

export default Delete;
